module.exports = __webpack_public_path__ + "img/edge_nature_lac.0d9b14dd.svg";